import React from 'react';
import ModalHOC from '../../hoc/Modal/ModalHOC';
import CustomerAddRatesByExcel from "../Customer/CustomerAddRatesByExcel";

let ModalUploadExcel = (props) =>{
    const id = props.extraData.idCustomer;
    const customer_number = props.extraData.customer_number;

    return (
        <div id="modal" className="modal">
            <div className="modal-background" onClick={props.closeModal }></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">{props.title}</p>
                    <button className="delete" aria-label="close" onClick={ props.closeModal }></button>
                </header>

                <section className="modal-card-body">
                    <CustomerAddRatesByExcel id={id} number={customer_number} modal="true"/>
                </section>

                <footer className="modal-card-foot">
                    <div className="h-36"></div>
                </footer>
            </div>
        </div>
    );
}

export default ModalHOC(ModalUploadExcel);
